export default __webpack_public_path__ + "static/media/bulkmicrobulk-temp.c9e9d690.JPG";